import { useStaticQuery, graphql } from 'gatsby'
import { FilterFields } from 'clientPages/explore/pages/columns/pageComponents/exploreReducer'

export type FilterOptions = {
  [key in FilterFields]: {
    distinct: string[]
  }
}

const useFilterOptions = () => {
  const filterOptions: FilterOptions = useStaticQuery(graphql`
    query filterOptionsQuery {
      Topic: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Topic)
      }
      Filter_1: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_1)
      }
      Filter_2: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_2)
      }
      Filter_3: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_3)
      }
      Filter_4: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_4)
      }
      Filter_5: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_5)
      }
      Filter_6: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_6)
      }
      Filter_7: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_7)
      }
      Filter_8: allAirtable(
        filter: { table: { eq: "Publishable explore page" } }
      ) {
        distinct(field: data___Filter_8)
      }
      Tags: allAirtable(filter: { table: { eq: "Publishable explore page" } }) {
        distinct(field: data___Tags)
      }
    }
  `)

  return filterOptions
}

export default useFilterOptions
